<script lang="ts">
    import type {AxiosInstance} from 'axios';

    import {dyData} from 'general/store';
    import {TEMPLATE} from 'general/constants';
    import Form from 'general/components/form/sms/Form.svelte';
    import OpacityItem from 'general/components/flip/opacityItem/OpacityItem.svelte';
    import Policy from 'general/components/policy/Policy.svelte';
    import Offer25 from 'desktop/icons/Offer25.svelte';

    import s from './style.module.css';

    export let instance: AxiosInstance;
</script>

<OpacityItem delayIn={0}>
    <div class={s.main}>
        <div class="descWrapper">
            <div class={s.descWrapper}>
                <p class={s.desc} class:smallScreen={$dyData.isSmallerScreen}>
                    Be a VIP, and unlock
                </p>
                <div class={s.imageWithDiscount} class:smallScreen={$dyData.isSmallerScreen}>
                    <Offer25 />
                </div>
                <p class={s.designerFrames} class:smallScreen={$dyData.isSmallerScreen}>
                    DESIGNER FRAMES
                </p>
            </div>
        </div>
        {#if $dyData.smsContent}
            <p class={s.smsContent} class:smallScreen={$dyData.isSmallerScreen}>
                {$dyData.smsContent}
            </p>
        {/if}
        <Policy side="sms" padding="12px" />
        <Form {instance} template={TEMPLATE.SQUARE_EXIT_REDESIGN} />
    </div>
</OpacityItem>
